export const lang = {
  "loading": {
    "a1": "Loading...",
    "a2": "No more data",
    // new1211
    "a3": "Subscribing...",
    "a4": "Payment in progress...",
    "a5": "Submitting...",
    "a6": "Redemption in progress...",
  },
  "tabbar": {
    "a1": "Home",
    "a2": "Positions",
    "a3": "Market",
    "a4": "Assets",
    "a5": "Mine"
  },
  "basic": {
    "a1": "Language Switch",
    "a2": "Confirm",
    "a3": "Cancel"
  },
  "notifyPopup": {
    "a3": "Confirm"
  },
  "gywm": {
    "a1": "About Us",
    "a2": "Company Profile",
    "a3": "Privacy Policy",
    "a4": "Service / Terms"
  },
  "yssm": {
    "a1": "1. Purpose and Scope",
    "a2": "This policy aims to protect users’ (individual or corporate) personal data ({value}) during platform usage.",
    "a3": "This policy applies to all personal data submitted or processed through this platform or its associated websites/systems — including account opening, trading, customer service, and backend operations.",
    "a4": "2. Types of Data Collection and Processing",
    "a5": "Information that may be collected and processed includes, but is not limited to:",
    "a6": "Identity Information:",
    "a7": "Name, ID/passport number or other government-issued identification, date of birth, tax ID (if applicable), etc.",
    "a8": "Contact Information:",
    "a9": "Address, email, phone number, etc.",
    "a10": "Account & Financial Information:",
    "a11": "Bank or payment account details, financial status, transaction records, source/use of funds, assets/liabilities, etc.",
    "a13": "Usage & Access Data:",
    "a14": "IP address, device information, browser type, login logs, cookies/tracking IDs, trading behavior, preferences, and habits.",
    "a15": "Other Voluntary Information:",
    "a16": "Such as risk disclosure data, compliance documents, verification files, communication records, etc.",
    "a17": "3. Purpose & Legal Basis of Data Processing",
    "a18": "Data may be collected and processed for the following purposes:",
    "a19": "To provide trading services, account management, and customer support;",
    "a20": "To comply with applicable laws and regulations (including AML, identity verification, tax compliance, securities regulations, etc.);",
    "a21": "To prevent fraud, money laundering, abuse of the platform, or security issues;",
    "a22": "To improve and maintain system/service security and stability;",
    "a23": "With user consent, data may also be used for marketing, news/notification updates, or product/service promotion.",
    "a24": "Legal bases may include user consent (consentimiento), necessity for contract fulfillment (prestación del servicio), and legal/regulatory obligations (obligación legal).",
    "a25": "4. Third-Party Processing & International Transfers",
    "a26": "If data must be transferred to third parties (such as payment processors, identity verification providers, cloud storage services, etc.), the platform must ensure usage only for contractual purposes and sign proper data-processing agreements.",
    "a27": "If data is transferred outside Argentina, appropriate technical, organizational, and contractual safeguards must be applied.",
    "a28": "5. Data Retention",
    "a29": "Personal data is retained only for the necessary period to fulfill relevant purposes, comply with legal/regulatory requirements, resolve disputes, or enforce contracts.",
    "a30": "Usage data (such as logs and cookies) may be used for internal analysis and security monitoring but must be retained for a reasonable, compliant period.",
    "a31": "6. User Rights",
    "a32": "Users, as data subjects, have the following rights under Argentina’s Law 25.326:",
    "a33": "Access their personal data (solicitar acceso)",
    "a34": "Correct/incomplete or inaccurate data (rectificación)",
    "a35": "Request deletion of data (when no legal basis for processing exists)",
    "a36": "Object to processing within legal limits (oponerse al tratamiento)",
    "a37": "If applicable, request restriction or data portability.",
    "a38": "The platform shall provide clear channels (email, form, or written request) for users to exercise these rights.",
    "a39": "7. Security Measures",
    "a40": "The platform shall implement appropriate technical (encryption, access control, log monitoring, etc.) and organizational measures to prevent unauthorized access, disclosure, misuse, alteration, or destruction of personal data.",
    "a41": "Despite reasonable security measures, inherent internet risks mean absolute security cannot be guaranteed.",
    "a42": "8. Policy Updates",
    "a43": "This privacy policy may be updated periodically. Significant changes will be announced through the platform or email.",
    "a44": "The updated policy becomes effective upon publication.",
    "a45": "9. Applicable Law & Regulatory Authority",
    "a46": "This policy is governed by Argentine law.",
    "a47": "The regulatory authority is the AAIP (Agencia de Acceso a la Información Pública)."
  },
  "fwtk": {
    "a1": "1. Acceptance of Terms",
    "a2": "Users must read and fully accept these terms before visiting or using the platform, creating an account, or performing transactions.",
    "a3": "If the user disagrees, they may not use the platform.",
    "a4": "2. Platform Rights",
    "a5": "The platform may modify, suspend, or terminate services, features, content, or access permissions at any time without notice.",
    "a6": "Modifications to these terms take effect upon publication.",
    "a7": "3. Legal Use & Prohibited Actions",
    "a8": "Users agree to use the platform in accordance with Argentine law, good-faith principles, and public order. The following are prohibited:",
    "a9": "Using the platform for illegal purposes or infringing third-party rights;",
    "a10": "Interfering with or disrupting platform functions, excessive requests, spam, automated scripts, bots, or scraping;",
    "a11": "Unauthorized access to or attempts to obtain other users’ accounts or sensitive information;",
    "a12": "Uploading or spreading viruses, malware, spyware, or harmful code;",
    "a13": "Impersonation, using false identities, or opening accounts with fake data;",
    "a14": "Reselling, transferring, or sharing account access without authorization;",
    "a15": "Unauthorized advertising, marketing, or selling products/services (unless approved by the platform);",
    "a16": "Any act violating laws, platform rules, or these terms.",
    "a17": "Violations may result in account suspension/termination and legal liability.",
    "a18": "4. Disclaimer & Risk Notice",
    "a19": "Information (such as security/stock quotes, analysis, news, or research reports) is for reference only and not investment, legal, or tax advice.",
    "a20": "Users bear all risks arising from securities trading or financial activities conducted via the platform.",
    "a21": "The platform is not liable for any direct/indirect damages resulting from using or being unable to use the service.",
    "a22": "5. Compliance & KYC/AML",
    "a23": "Users may be required to provide identity verification, proof of address, source of funds, or compliance documents.",
    "a24": "The platform may refuse account opening or suspend transactions for compliance reasons without explanation.",
    "a25": "6. Privacy Policy Integration",
    "a26": "Users agree that personal data is collected and processed according to the Privacy Policy.",
    "a27": "The Privacy Policy and these Terms together constitute the Agreement.",
    "a28": "7. Governing Law & Disputes",
    "a29": "These terms are governed by Argentine law. Disputes shall be submitted to the Ordinary Courts of Buenos Aires.",
    "a30": "8. Contact",
    "a31": "For inquiries regarding privacy, data protection, account, or transactions, please contact {value}."
  },
  "addDebitCard": {
    "a1": "Add Bank Card",
    "a2": "Name",
    "a3": "Please enter name",
    "a4": "Bank Name",
    "a5": "Please enter bank name",
    "a6": "Please enter 22-digit {value}",
    "a7": "Account Type",
    "a8": "Please enter account type",
    "a9": "Submit",
    "c1": "Binding Successful",
    "c2": "Must be a 22-digit number"
  },
  "asset": {
    "a1": "Total Assets",
    "a2": "Market Value",
    "a3": "Available Balance",
    "a4": "Frozen Amount",
    "a5": "Total Profit",
    "a6": "Deposit",
    "a7": "Withdraw",
    "a8": "Asset Conversion",
    "a9": "Funding Records",
    "a10": "Fund Password",
    "a11": "Apply for Loan",
    "a12": "Deposit Method",
    "a13": "Withdrawal Method",
    "c1": "Real-name Authentication Required",
    "c2": "Verify Now",
    "c3": "Cancel",
    "c4": "Withdrawal requires real-name verification. Go to verify?",
    "c5": "View Verification",
    "c6": "Verification in progress. Please withdraw after approval."
  },

  "assetConversion": {
    "a1": "Asset Conversion",
    "a2": "Funding Records",
    "a3": "From",
    "a4": "Available Balance",
    "a5": "Please enter the amount",
    "a6": "Please select currency to convert",
    "a7": "To",
    "a8": "Current Balance:",
    "a9": "Amount Received",
    "a10": "Actual amount may vary",
    "a11": "Submit Now"
  },

  "dayTrading": {
    "a1": "AI Trading",
    "a2": "Order Submitted",
    "a3": "Applied",
    "a4": "Trading",
    "a5": "Trading Details",
    "a6": "Participation Period:",
    "a7": "Enter amount (minimum {value})",
    "a8": "Submit",
    "a9": "Order Number",
    "a10": "Order Status",
    "a11": "Pending Review",
    "a12": "Order Amount",
    "a13": "Rejected",
    "a14": "Order Number",
    "a15": "Order Status",
    "a16": "Closed",
    "a17": "Trading Type",
    "a18": "Buy Long",
    "a19": "Closing Time",
    "a20": "Quantity",
    "a21": "Buy Price",
    "a22": "Total Buy Price",
    "a23": "Fee",
    "a24": "Sell Price",
    "a25": "Total Sell Price",
    "a26": "Profit Amount",
    "a27": "Confirm",
    "a28": "Cancel",
    "a29": "Product Introduction",
    "a30": "Based on the Argentine All-Share Index, using AI-driven diversified market allocation with stable risk control and consistent growth.",
    "a31": "This fund focuses on the 30 largest and most liquid U.S. stocks, adopting an equal-weight strategy to diversify risks.",
    "a32": "Five-day investment with 1.5–3% expected daily returns.",
    "a33": "Focuses on state-owned and leading oil and gas companies.",
    "a34": "Expected Returns",
    "a39": "Investment Strategy",
    "a40": "Trading Cycle",
    "a41": "Total rate: {value}",
    "a42": "Investment Amount",
    "a43": "Available Balance: {value}",
    "a44": "Minimum Limit {value}",
    "a45": "Insufficient Balance",
    // new
    "c1": "Amount cannot be empty",
    // new1206
    "a35": "Based on an investment of {value} ten thousand pesos, it is expected to achieve a return of 0.5% to 1% per trading day within 1 to 3 trading days, with an average daily profit of approximately {value2} pesos.",
    "a36": "Based on an investment of {value} ten thousand pesos, it is expected to achieve a return of 1% to 1.5% per trading day within 1 to 3 trading days, with an average daily profit of approximately {value2} pesos.",
    "a37": "An investment of {value} ten thousand pesos over a period of 5 trading days is expected to generate a return of 1.5% to 2% per trading day, with an average daily profit of {value2} ten thousand pesos.",
    "a38": "An investment of {value} ten thousand pesos over a period of 7 trading days is expected to generate a return of 3% to 5% per trading day, with an average daily profit of {value2} ten thousand pesos.",
    "b1": "{value} day"
  },
  "etf": {
    "a1": "Product Redemption",
    "a2": "History Orders",
    "a3": "Order Number",
    "a4": "Product",
    "a5": "Cycle (days)",
    "a6": "Purchase Time",
    "a7": "Expiration Time",
    "a8": "Investment Amount",
    "a9": "Total Expected Profit",
    "a10": "Days Held",
    "a11": "Released Amount",
    "a12": "Status",
    "a13": "Redeemed",
    // 
    "c1": "Pending",
    "c2": "In Trading",
    "c3": "Trade Password"
  },
  "fundAccountManage": {
    "a1": "Fund Account Management",
    "a2": "Add Bank Card",
    // newText
    "a3": "Bank Card Management",
    "a4": "Address Binding",
    "a5": "Address Type",
    "a6": "Address",
    "a7": "Delete Confirmation",
    "a8": "Confirm",
    "a9": "Cancel",
    "a10": "Are you sure to delete this card?",
    "a11": "ERC address cannot be empty",
    "a12": "TRC address cannot be empty",
    "a13": "To modify a bound address, please contact customer service",
    "a14": "ERC20 Address",
    "a15": "TRC20 Address"
  },
  "fundingRecords": {
    "a1": "Funding Records",
    "a2": "Purchase Details",
    "a3": "Funds Deposited",
    "a4": "Withdrawal",
    "a5": "Conversion",
    "a6": "Credited",
    "a7": "Requested Amount",
    "a8": "Actual Credited Amount",
    "a9": "Amount",
    "a10": "Time",
    // newText
    "a11": "Income",
    "a12": "Expense",
    "a13": "Top-up Amount",
    "a14": "Incomplete",
    "a15": "Completed",
    "a16": "Canceled",
    "a17": "Pending Review",
    "a18": "Credited",
    "a19": "Review Failed",
    "a20": "Withdrawal Refund"
  },
  "fundPassword": {
    "a1": "Fund Password",
    "a2": "Original Password",
    "a3": "Enter Original Password",
    "a4": "New Password",
    "a5": "Enter New Password",
    "a6": "Confirm Password",
    "a7": "Enter Confirmation Password",
    "a8": "Submit Now",
    // newText
    "a9": "Please enter a 6-digit numeric password",
    "a10": "Must be 6 digits",
    "a11": "Password",
    "a12": "Please enter confirmation password",
    "a13": "The two passwords do not match"
  },
  "index": {
    "a1": "Block Trades",
    "a2": "Day Trading",
    "a3": "KYC Verification",
    "a4": "Online Support",
    "a5": "Global Index",
    "a6": "More",
    "a7": "Hot Stocks",
    "a8": "Favorites",
    "a9": "Argentina",
    "a10": "US Stocks",
    "a11": "Stock / Code",
    "a12": "Latest Price ({value})",
    "a13": "Change",
    // newText
    "a14": "Smart Trading System",
    "a15": "Based on deep learning models with 10-year historical backtesting.",
    "a16": "Fast. Secure. Fluid. Block trading redefined",
    "a17": "Bulk Discounts",
    "a18": "AI Trading",
    "a19": "About Us",
    "a20": "FAQ",
    "a21": "No Data",
    "a22": "Complete KYC to receive trial funds",
    "a23": "KYC Verification",
    "a24": "Congratulations! Your KYC is approved. Trial funds have been issued.",
    "a25": "Start Investing",
    "a26": "AI Auto-Investing",
    "a27": "View Earnings",
    "a28": "Latest Price",
    "a29": "Currently in a position",
    "a30": "Closed position",
  },
  "ipo": {
    "a1": "IPO Subscription",
    "a2": "Subscribed",
    "a3": "In Trading",
    "a4": "Details",
    "a5": "Auto-Subscribe",
    "a6": "Not Allotted",
    "a7": "Subscription Quantity",
    "a8": "Allotment Time",
    "a9": "Allotment Qty",
    "a10": "Estimated Profit",
    "a11": "To Be Paid",
    "a12": "Paid",
    "a13": "Offering Price",
    "a14": "Market Price",
    "a15": "Closed",
    // newText
    "a16": "Pending Allotment",
    "a17": "Allotted",
    "a18": "Rejected",
    "a19": "Trade Password",
    "a20": "Product Details",
    "a21": "Issued Quantity",
    "a22": "Issue Price",
    "a23": "Stock Code",
    "a24": "Exchange Rate",
    "a25": "Deadline",
    "a26": "Subscribe Now",
    "a27": "Order Number",
    "a28": "Deadline",
    "a29": "Pay now",
    "a30": "Winning Price",
    "a31": "Winning Shares",
    "a32": "Total Winning Price",
    "a33": "Total Profit",
    "a34": "Launch date",
    "a35": "Release Date",
    "a36": "Rejection Reason",
    ////
    "a37": "Pending review",
    "a38": "Pending payment",
    "a39": "Awaiting listing",
    "a40": "Closed position",
    "a41": "Rejected",
    "a42": "Subscribed",
    "a43": "Deadline has been closed.",
    "a44": "redemption",
  },
  "login": {
    "a1": "Enter Mobile Number",
    "a2": "Enter Password",
    "a3": "Online Support",
    "a4": "Forgot Password?",
    "a5": "Secure Login",
    "a6": "No Account?",
    "a7": "Register",
    // newText
    "a8": "Login",
    "a9": "Welcome back! Please log in.",
    "a10": "Invalid phone number format",
    "a11": "Login Successful"
  },
  "register": {
    "a1": "Re-enter Password",
    "a2": "Invitation Code (required)",
    "a3": "Already have an account?",
    "a4": "Login",
    "a5": "Secure Registration",
    // newText
    "a6": "Register",
    "a7": "Create New Account",
    "a8": "Enter Mobile Number",
    "a9": "Invalid phone number format",
    "a10": "Enter Password",
    "a11": "At least 6 characters with letters and numbers",
    "a12": "Enter Confirmation Password",
    "a13": "Passwords do not match",
    "a14": "Enter Invitation Code"
  },
  "mail": {
    "a1": "notify",
    "a2": "Delete",
    // newText
    "a3": "System Notice",
    "a4": "Order Notice",
    "a5": "Order No.",
    "a6": "Review Result",
    "a7": "Trial Fund Notice",
    "a8": "Private Message",
    "a9": "Currency",
    "a10": "Market Price",
    "a11": "Purchase Price",
    "a12": "Expiration Time",
    "a13": "pass"
  },
  "market": {
    "a1": "Enter stock name",
    "a2": "Search",
    "a3": "Favorites",
    "a4": "Argentine Stocks",
    "a5": "US Stocks",
    "a6": "News",
    "a7": "Stock / Code",
    "a8": "Latest Price",
    "a9": "Change",
    // newText
    "a10": "Latest Price",
    "a11": "View Details",
    "a12": "Positive",
    "a13": "Negative",
    "a14": "Neutral"
  },
  "marketDetail": {
    "a1": "Market",
    "a2": "Open",
    "a3": "Previous Close",
    "a4": "High",
    "a5": "Low",
    "a6": "Buy",
    "a7": "Total purchase price",
    "a8": "Available Funds",
    "a9": "Total Funds",
    "a10": "Leverage",
    "a11": "Buy Quantity",
    "a12": "Enter Quantity",
    "a13": "Take-Profit Price",
    "a14": "Enter Take-Profit Price",
    "a15": "Stop-Loss Price",
    "a16": "Enter Stop-Loss Price",
    "a17": "Confirm",
    "a18": "Time:",
    "a19": "Open:",
    "a20": "Close:",
    "a21": "Low:",
    "a22": "High:",
    // newText
    "a23": "Current Price",
    "a24": "Enable Take-Profit",
    "a25": "Enable Stop-Loss",
    "a26": "You can buy up to",
    "a27": "shares",
    "a28": "Enter buy quantity",
    "a29": "Enter stop-loss price",
    "a30": "Stop-loss cannot be higher than current price",
    "a31": "Enter take-profit price",
    "a32": "Take-profit cannot be lower than current price"
  },
  "mine": {
    "a1": "Verified",
    "a2": "Available Funds",
    "a3": "Available Funds",
    "a4": "KYC Verification",
    "a5": "Change Login Password",
    "a6": "Fund Management",
    "a7": "Online Support",
    "a8": "Language Switch",
    "a9": "Logout",
    // newText
    "a10": "Under Review",
    "a11": "Rejected",
    "a12": "Not Verified",
    "a13": "Anti-fraud Zone"
  },
  "newsDetail": {
    "a1": "News"
  },
  "otc": {
    "a1": "Order Submitted",
    "a2": "Pending Review",
    "a3": "Trading Details",
    "a4": "Rejected",
    "a5": "Market Price",
    "a6": "Discount Price",
    "a7": "Earnings per Share",
    "a8": "Minimum Purchase Qty",
    "a9": "Enter Quantity",
    "a10": "Total Buy Price",
    "a11": "Available Balance",
    "a12": "Confirm",
    "a13": "Pending Review",
    "a14": "Buy Time",
    "a15": "Quantity",
    "a16": "Market Price",
    "a17": "Discount Price",
    "a18": "Total Funds",
    "a19": "Closed",
    "a20": "Rejected",
    // newText
    "a21": "Bulk Discount",
    "a22": "Product Subscription",
    "a23": "Allocated",
    "a24": "Trading Details",
    "a25": "Rejected",
    "a26": "Subscription Price",
    "a27": "Current Price",
    "a28": "Premium",
    "a29": "Publish Time",
    "a30": "Deadline",
    "a31": "Subscribed",
    "a32": "Subscribe Now",
    "a33": "Pending Payment",
    "a34": "Order Number",
    "a35": "Subscription Price",
    "a36": "Allocated Shares",
    "a37": "Total Subscription Price",
    "a38": "Paid",
    "a39": "Unpaid",
    "a40": "Expected Profit",
    "a41": "Subscription Time",
    "a42": "Pay Now",
    "a43": "Holding",
    "a44": "Start Time",
    "a45": "End Time",
    "a46": "Redeem",
    "a47": "Rejection Reason",
    "a48": "Subscription Confirmation",
    "a49": "Confirm",
    "a50": "Cancel",
    "a51": "Subscribe now to earn more! Confirm subscription?",
    "a52": "Payment Confirmation",
    "a53": "Pay now to earn more! Confirm payment?",
    "a54": "Redemption Confirmation",
    "a55": "Confirm immediate redemption?",
    "a56": "Sell Confirmation",
    "a57": "Continue holding to earn more. Confirm selling?",
    // new1206
    "c1": "Subscribed Successfully",
    "c2": "Payment Deadline"
  },
  "positionDetails": {
    "a1": "Trade Details",
    "a2": "Closed",
    "a3": "Order Number",
    "a4": "Sell Price",
    "a5": "Sell Time",
    "a6": "Buy Time",
    "a7": "Trade Type",
    "a8": "Buy Long",
    "a9": "Closing Quantity",
    "a10": "Buy Price",
    "a11": "Contract Amount",
    "a12": "Fee",
    "a13": "Closing Fee",
    "a14": "Market Price",
    "a15": "Actual P/L",
    "a16": "Yield",
    "a17": "Leverage"
  },
  "realNameAuthentication": {
    "a1": "KYC Verification",
    "a2": "Approved",
    "a3": "ID Verification",
    "a4": "Upload Front Side",
    "a5": "Upload Back Side",
    "a6": "Full Name",
    "a7": "Enter Full Name",
    "a8": "ID Number",
    "a9": "Enter 8-digit ID Number",
    "a10": "Submit",
    // newText
    "a11": "Verified",
    "a12": "Under Review",
    "a13": "Review failed, please resubmit",
    "a14": "Phone",
    "a15": "Enter Phone Number",
    "a16": "Email",
    "a17": "Enter Email (optional)",
    "a18": "Please upload ID card",
    "a19": "Please enter name",
    "a20": "Please enter ID number",
    "a21": "Please enter phone number",
    "a22": "Invalid email format",
    "a23": "ID number must be 11 digits",
    "a24": "The phone number must be 10 digits",
    // newText2
    "c1": "Notice",
    "c2": "Confirm",
    "c3": "Submission successful, please wait for review!",
    // new1208
    "c4": "Reasons for rejection"
  },
  "topUp": {
    "a1": "Top Up",
    "a2": "Copy",
    // newText
    "a3": "Top-up Amount",
    "a4": "Please enter the amount",
    "a5": "Minimum",
    "a6": "Amount to Pay",
    "a7": "Fee",
    "a8": "Actual Amount",
    "a9": "If you need other payment channels, please contact customer service",
    "a10": "Contact Customer Service",
    "a11": "Notification",
    "a12": "Contact Customer Service",
    "a13": "Cancel",
    "a14": "Transfers are currently prohibited. Please complete your transaction between 9:00 AM and 10:00 PM. For any questions, please contact customer service or top up your account using virtual currency.",
    "a15": "Minimum top-up amount is",
    "a16": "Please enter top-up amount",
    "a17": "Loading payment page...",
    "a18": "Top Up",
    "a19": "If you need other payment channels, please contact customer service",
    "a20": "Note: This channel only supports { value } chain crypto top-up, minimum top-up is { value2 }",
    "a22": "Copied successfully"
  },
  "transaction": {
    "a1": "Argentina",
    "a2": "US Stocks",
    "a3": "Please enter search keywords",
    "a4": "Search",
    "a5": "Subscription",
    "a6": "ETF Holdings",
    "a7": "In Progress",
    "a8": "Ended",
    "a9": "Market Value {value}",
    "a10": "Available Funds {value}",
    "a11": "P/L {value}",
    "a12": "Not Winning",
    "a13": "Closed",
    "a14": "Estimated Profit",
    "a15": "Subscription Price {value}",
    "a16": "Subscription Quantity",
    "a17": "Allocation Date",
    "a18": "Winning",
    "a19": "Paid {value}",
    "a20": "Pending Payment {value}",
    "a21": "Stock Name",
    "a22": "Current Price {value}",
    "a23": "Cost {value}",
    "a24": "Holding",
    "a25": "Market Value",
    "a26": "PnL",
    "a27": "In Position",
    "a28": "Return Rate",
    "a29": "Buy Time",
    "a30": "Expiration Time",
    "a31": "Fund Name",
    "a32": "Amount Bought",
    "a33": "Daily Profit",
    "a34": "Daily Yield",
    // newText
    "a35": "Total Profit",
    "a36": "Total Yield",
    "a37": "Trading Cycle",
    "a38": "Stock Name",
    "a39": "Sell Price {value}",
    "a40": "Closed Quantity",
    "a41": "P/L",
    "a42": "PnL",
    "a43": "Closed",
    "a44": "AI Trading",
    "a45": "Block Discount",
    "a46": "Stock",
    "a47": "In Position",
    "a48": "Order No.",
    "a49": "Subscription Price",
    "a50": "Allocated Shares",
    "a51": "Total Subscription Price",
    "a52": "Paid",
    "a53": "Pending Payment",
    "a54": "Estimated Profit",
    "a55": "Start Time",
    "a56": "Expiration Time",
    "a57": "Redeem",
    "a58": "Revenue",
    "a59": "Sell",
    "a60": "Trading",
    "a61": "Trading Cycle",
    "a62": "days",
    "a63": "Estimated Profit",
    "a64": "Expiration Time",
    "a65": "Subscription Time",
    "a66": "Redemption Confirmation",
    "a67": "Confirm",
    "a68": "Cancel",
    "a69": "Are you sure you want to redeem now?",
    "a70": "Sell Confirmation",
    "a71": "Are you sure you want to sell now?",
    // new1206
    "d1": "Close Position",
    "d2": "Take Profit",
    "d3": "Stop Loss"
  },
  "updateLoginPassword": {
    "a1": "Change Login Password",
    "a2": "Current Password",
    "a3": "Please enter current password",
    "a4": "New Password",
    "a5": "Please enter new password",
    "a6": "Confirm Password",
    "a7": "Please confirm your password",
    "a8": "Submit Now",
    // newText
    "a9": "At least 6 characters with a combination of letters and numbers",
    "a10": "Passwords do not match"
  },
  "withdrawal": {
    "a1": "Withdrawal",
    "a2": "Available Funds",
    "a3": "Bank Card",
    "a4": "Please select a bank card",
    "a5": "Please enter withdrawal amount",
    "a6": "Submit",
    "a7": "Please select bank card",
    "a8": "Bind Now",
    "a9": "Confirm",
    // newText
    "a10": "Actual Amount Received",
    "a11": "Fee",
    "a12": "Security Reminder",
    "a13": "Confirm",
    "a14": "Please set a transaction password first",
    "a15": "Submitted successfully. Bank channels are busy, funds will arrive within 24 hours",
    "a16": "Please select a bank card",
    "a17": "Please enter withdrawal amount",
    "a18": "Minimum withdrawal amount",
    // 
    "c1": "Submitted successfully"
  },
  // 阿根廷语言包缺失
  "notifyPopupOtc": {
    "a1": "Block Discount Subscription Notice",
    "a2": "You have multiple block discount products pending subscription",
    "a3": "You have one block discount product pending subscription",
    "a4": "Stock Name:",
    "a5": "Subscription Price:",
    "a6": "Market Price:",
    "a7": "Currency:",
    "a8": "Deadline:",
    "a10": "Stock Type:",
    "a11": "Purchase Price:",
    "a12": "Shares:",
    "a13": "Stock Trading Code:",
    "a14": "Order No.:",
    "a15": "Payment Time:",
    "a16": "Company Name:",
    "a17": "Stock Type:",
    "a18": "Amount:",
    "a19": "Order No.:",
    "a20": "Review Status:",
    "a21": "User Remarks:",
    // new1206,
    "a9": "Stock Name:",
    "d1": "Multiple block orders have been successfully allocated",
    "d2": "One block order has been successfully allocated",
    "d3": "Block Order Notification",
    "d4": "Multiple block orders have been rejected",
    "d5": "One block order has been rejected",
    "d6": "Block Order Rejection Notice",
    "d7": "Rejected"
  },
  "tyjPopup": {
    "a1": "Trial bonus",
    "a2": "Remaining Claim Time",
    "a3": "Trial Bonus",
    "a4": "Confirm",
    // newText
    "a5": "Congratulations, identity verification approved",
    "a6": "You received",
    "a7": "Trial Bonus",
    "a8": "Event Countdown",
    "a9": "Invest Now"
  },
  "aiTransactionDetails": {
    "a1": "Trading Details",
    "a2": "Date",
    "a3": "Daily Profit",
    "a4": "Stock Details",
    "a5": "Buy Price",
    "a6": "Sell Price",
    "a7": "Holding Quantity",
    "a8": "Daily Earnings",
    //
    "c1": "Smart Trading..."
  },
  "aiTransactionRecords": {
    "a1": "AI Trading Records",
    "a2": "Trading",
    "a3": "Transaction Details",
    "a4": "Trading Cycle",
    "a5": "Estimated Profit",
    "a6": "Expiration Time",
    "a7": "Subscription Time",
    "a8": "View Details",
    "a9": "days",
    // new
    "c1": "Pending",
    "c2": "Trading",
    "c3": "Closed",
    "c4": "Task Failed"
  },
  "fqa": {
    "a1": "FAQ",
    "a2": "Matrix is invited by the Argentine government and conducts trading based on NASDAQ, the world's second largest exchange, strictly regulated by SEC and FINRA.",
    "a3": "Currently during the early promotion period, trading is free of charge. Withdrawal fee is 1–0.3%. Exchange rate follows Argentina Peso to USD.",
    "a4": "Deposits have no fees. Large deposits require prior notice. All operations are regulated by government and banks.",
    "a5": "Market fluctuation is normal. There are risks and profits. The company provides AI trading and block discount strategies.",
    "a6": "The platform uses real-time Argentina and US market data.",
    "a7": "Regulated by SEC and FINRA. Withdrawal has normal fees.",
    "a8": "Users can bind personal info and bank cards. If trading fails, it is a market behavior, not related to the company.",
    "a9": "Users must operate normally and understand market risks. KYC is required.",
    "a11": "1. Is the platform legal & regulated?",
    "a12": "2. Trading fees, commissions, exchange rate cost?",
    "a13": "3. Are deposit/withdrawals safe?",
    "a14": "4. Market/liquidity/volatility risks?",
    "a15": "5. Is the data accurate?",
    "a16": "6. Legal & tax responsibilities?",
    "a17": "7. Are funds safe? How to appeal?",
    "a18": "8. How should users use the product?"
  },
  // newText
  "loan": {
    "a1": "Apply for Loan",
    "a2": "Phone Number",
    "a3": "Please enter phone number",
    "a4": "Incorrect phone number format",
    "a5": "Name",
    "a6": "Please enter name",
    "a7": "Email",
    "a8": "Please enter email",
    "a9": "Amount",
    "a10": "Please enter loan amount",
    "a11": "You are not eligible for a loan. Please contact customer service."
  },
  "loanRecords": {
    "a1": "Loan Records",
    "a2": "Borrower",
    "a3": "Pending Review",
    "a4": "Approved",
    "a5": "Rejected"
  },
  "withdrawalu": {
    "a1": "Withdrawal Address",
    "a2": "Actual Amount Received",
    "a3": "Fee",
    "a4": "Binding Notice",
    "a5": "Confirm",
    "a6": "Please bind TRC withdrawal address first",
    "a7": "Security Notice",
    "a8": "Please set transaction password first",
    "a9": "Withdrawal address cannot be empty",
    "a10": "Please enter withdrawal amount",
    "a11": "Minimum withdrawal amount",
    "a12": "Please bind ERC withdrawal address first"
  },
  "about": {
    "a1": "We are an early-stage venture capital firm investing from concept stage to Series A. Our team consists of former founders and builders who have worked with Apple, FedEx, Oculus, and Canva.",
    "a2": "We are contrarian investors, backing founders with deep technical expertise and strong vision.",
    "a3": "Team",
    "a4": "We are a close-knit team of former founders and builders. We select investments carefully and invest time deeply.",
    "a5": "We act early and stay committed long-term.",
    "a6": "Investments",
    "a7": "Ilya Sukhan",
    "a8": "AI, Infrastructure",
    "a9": "August Health, Chameleon, Fivetran, Flock Safety, Mashgin, Parabola, Sieve",
    "a10": "Dana Stalder",
    "a11": "Fintech, B2B",
    "a12": "ApartmentList, Baselane, EarnIn, Flexible Finance, Mudflap, Side, Steadily, Zest AI",
    "a13": "Antonio Rodriguez",
    "a14": "AI, Frontier Tech",
    "a15": "August Health, Chameleon, Fivetran, Flock Safety, Mashgin, Parabola, Sieve",
    "a16": "Kojo Osei",
    "a17": "AI, Infrastructure",
    "a18": "Hookdeck, Ampersand, LM Studio",
    "a19": "Projects",
    "a20": "Challengers, contrarians, adventurers, and disruptors. Our portfolio companies are founded by visionary, deeply technical founders.",
    "a21": "Contact — It’s never too early",
    "a22": "San Francisco",
    "a23": "535 Mission St, Suite 2600, San Francisco, CA 94105, Tel: 650-798-1600",
    "a24": "Boston",
    "a25": "101 Main St, 17th Floor, Cambridge, MA 02142, Tel: 617-494-1223"
  },
  "AiTrialBonus": {
    "a3": "Claim Trial Bonus",
    "a4": "Start AI Investing",
    "a5": "Earn Profits",
    "a6": "Trial Strategy",
    "a7": "Investment Cycle",
    "a8": "Expected Yield",
    "a9": "Trial Bonus",
    "a10": "Submit",
    "a11": "My Earnings",
    "a12": "Total Current Investment Earnings",
    "a13": "Daily Earnings",
    "a14": "Buy",
    "a15": "Sell",
    "a16": "Holding Quantity",
    "a17": "Profit",
    "a18": "Awaiting Profit",
    "a19": "Activity Reminder",
    "a20": "Back",
    "a21": "This event has ended!",
    "a1": "Claim Trial Funds",
    "a2": "AI Algorithm Analysis + Professional Risk Control ensures every investment is transparent, safe, and controllable — safeguarding your assets",
    "b1": "Use AI to Win Future Wealth",
    "b2": "day"
  },
  "notifyPopupKyc": {
    "a1": "Congratulations on registering! Please complete identity verification!",
    "a2": "Go to Verification"
  },
  "store": {
    "a1": "Verification Reminder",
    "a2": "Verify Now",
    "a3": "Cancel",
    "a4": "Trading requires verification. Proceed to verify?",
    "a5": "View Verification",
    "a6": "Verification pending, trading is currently unavailable!"
  },
  // 1209
  "newRouter": {
    "a1": "Please log in first",
    "a2": "Logging in...",
    "a3": "Registering..."
  },
  "utils": {
    "a1": "{value}day {value2}hour {value3}minute {value4}second"
  },
  "oneStocks": {
    "a1": "Highest",
    "a2": "Lowest",
    "a3": "Average Price",
    "a4": "Trading Volume",
    "a5": "Previous Opening",
    "a6": "Previous Closing",
    "a7": "Volatility",
    "a8": "High Discount",
    "a9":"Go to trade"
  },
  "antiFraud": {
    "a1": "Anti-Fraud Zone",
    "a2": "Fraud Identification",
    "a3": "You can copy the official link or contact information in the SMS/message for verification. Do not click on unofficial links or enter any account password information.",
    "a4": "Submit",
    "a5": "Important Announcement",
    "a6": "Fraud Reporting Channels",
    "a7": "Shell Company Scams",
    "a8": "'Pump and Dump' or 'Promote High Prices for Retail Investors' Scams",
    "a9": "'Short Selling to Accumulate Funds' Scams!",
    "a10": "Retirement Account Scams!",
    "a11": "Fake Familiarity Scams!",
    "a12": "We will strictly protect your personal information security.",
    "a13": "Your trust is very important to us. We understand the importance of your personal information. We will take strict security measures in accordance with laws and regulations to fully protect your personal information security. You can learn more about this through the following 'Privacy Policy' and 'Terms of Service'.",
    "a14": "Privacy Policy",
    "a15": "Terms of Service", "a16": "The verification content cannot be empty",
    "a17": "Submission successful! Please wait patiently for customer service to contact you",
    "a18": "Fraud reporting channels",
    "a19": "FBI — Crime Complaints Center",
    "a20": "UK National Fraud and Cybercrime Reporting Centre",
    "a21": "Korean National Police Agency",
    "a22": "Japanese National Police Agency",
    "a23": "European Union",
    "a24": "Details",
    "a25": "Anyone can become a target of financial fraud and scams. The best defense is to stay informed, vigilant, and safe. Below is information about the most common financial services scams, along with key advice and tips to help you avoid becoming the next victim!",
    "a26": "Shell Company Scam",
    "a27": "Scammers may impersonate a legitimate company to trick you into transferring money to their account. In some cases, scammers may impersonate a representative or a reputable financial services company, including Interactive Brokers. The purpose of a shell company scam is to lure you into transferring money to an account that appears legitimate but is actually held by a scammer.",
    "a28": "Pump and dump\" or \"hype up and sell\" scams",
    "a29": "In these scams, fraudsters first invest in a stock, then spread false or misleading information to create a buying frenzy, artificially 'pumping up' the stock price. Then, the fraudsters sell their own shares at the high price and stop promoting the stock. As the price falls, other investors suffer losses. This 'first-hand' investment advice from 'insiders' is provided to you based on your privileged or special status.",
    "a30": "Short selling and accumulation\" scams",
    "a31": "This is the opposite of the 'pump and dump' scam. In the 'short selling and accumulation' scam, fraudsters spread false information, leading investors to believe that a relatively illiquid stock will plummet and should be sold. When investors see this information and sell the stock, causing a sharp price drop, the fraudsters enter the market and buy shares at a low price.",
    "a32": "Retirement account scams", "a33": "To withdraw funds from a retirement account, the recipient must meet a minimum age requirement. Generally, early withdrawal of retirement funds often incurs penalties. In this scam, fraudsters claim to be able to help people withdraw retirement funds early without paying penalties through tax loopholes, then use complex schemes to erode the retirement account's assets through commissions, investments, etc.",
    "a34": "Predatory Privilege Scam",
    "a35": "Scammers who commit predatory privilege scams are usually (or pretend to be) members of their target group. They understand that people are more likely to trust those with similar backgrounds, so they use age, religion, race, gender, or professional identity to gain the victim's trust. Predatory privilege scams almost always involve fake investments or investments where the scammer conceals important information (such as the risk of loss, investment history, or the background of the scheme's initiator)." ,
    "a36": "Many scams targeting acquaintances are Ponzi schemes or pyramid schemes. Funds provided by new investors to the scheme's initiators are used to pay earlier investors, creating the illusion of successful investment. Finally, when the new investors' funds run out and existing investors demand returns, the scam collapses, and investors discover that most or all of their money has vanished."
  }
};